
import { Component, Prop, Vue } from 'vue-property-decorator';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import BulkJobHistory from '@/components/shared/bulk-job/BulkJobHistory.vue';

@Component<ActionHistoryModal>({
	components: {
		StandardModal,
		BulkJobHistory
	}
})
export default class ActionHistoryModal extends Vue {
	@Prop({ type: Boolean, required: false, default: false }) private showModal!: boolean;
	@Prop({ type: String, required: true }) private idPrefix!: string;
	@Prop({ type: Array, required: true }) private jobs!: BulkJob[];
	@Prop({ type: Number, required: true }) private totalCount!: number;
	@Prop({ type: Number, required: true }) private currentPage!: number;
	@Prop({ type: Number, required: true }) private itemsPerPage!: number;
	@Prop({ type: String, required: true }) private sortBy!: string;
	@Prop({ type: String, required: true }) private sortDirection!: 'asc' | 'desc';
	@Prop({ type: Boolean, required: false, default: false }) private isLoading!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private showActionColumn!: boolean;
	// Only the menu history is searchable — the settings history is short enough not to need it.
	@Prop({ type: Boolean, required: false, default: false }) private searchable!: boolean;
}
